import React from 'react';

/**
 * Non-blocking banner shown after adding an activity/wishlist item
 * when a UNESCO World Heritage Site is detected nearby.
 *
 * Props:
 *   suggestion   - { site_id, name, country, year, distance_m, matched_address }
 *   onConfirm    - called when user clicks "Add label"
 *   onDismiss    - called when user clicks "Dismiss"
 */
export default function UnescoSuggestionBanner({ suggestion, onConfirm, onDismiss }) {
  if (!suggestion) return null;

  const distKm = suggestion.distance_m < 1000
    ? `${suggestion.distance_m} m`
    : `${(suggestion.distance_m / 1000).toFixed(1)} km`;

  return (
    <div className="tp-unesco-banner">
      <div className="tp-unesco-banner__icon">🏛</div>
      <div className="tp-unesco-banner__body">
        <div className="tp-unesco-banner__title">UNESCO World Heritage Site detected</div>
        <div className="tp-unesco-banner__row">
          <span className="tp-unesco-banner__label">Detected site:</span>
          <span className="tp-unesco-banner__value">{suggestion.name}</span>
          {suggestion.year && (
            <span className="tp-unesco-banner__meta">({suggestion.year})</span>
          )}
        </div>
        <div className="tp-unesco-banner__row">
          <span className="tp-unesco-banner__label">Matched address:</span>
          <span className="tp-unesco-banner__value tp-unesco-banner__value--address">
            {suggestion.matched_address || '—'}
          </span>
          <span className="tp-unesco-banner__meta">{distKm} away</span>
        </div>
      </div>
      <div className="tp-unesco-banner__actions">
        <button className="tp-btn--ghost tp-btn--sm" onClick={onConfirm}>
          Add label
        </button>
        <button className="tp-unesco-banner__dismiss" onClick={onDismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
}
